export const getStatusLabel = (
  status: string
) => {
  if (status === "PAID") return "Pagado";

  if (status === "PARTIAL") return "Pago parcial";

  if (status === "OVERDUE") return "Vencido";

  return "Pendiente";
};

export const getStatusClasses = (
  status: string,
  isActive: boolean
) => {
  /**
   * 🔥 cuando está seleccionado
   * mantenemos consistencia visual
   */
  if (isActive) {
    return `
      bg-white/20
      text-white
      border border-white/20
    `;
  }

  /**
   * ✅ Pagado
   */
  if (status === "PAID") {
    return `
      bg-success bg-opacity-10
      text-success
      border border-success border-opacity-20
    `;
  }

  /**
   * ⚠️ Parcial
   */
  if (status === "PARTIAL") {
    return `
      bg-warning bg-opacity-10
      text-warning
      border border-warning border-opacity-20
    `;
  }

  /**
   * ❌ Vencido
   */
  if (status === "OVERDUE") {
    return `
      bg-danger bg-opacity-10
      text-danger
      border border-danger border-opacity-20
    `;
  }

  /**
   * 🔵 Pendiente
   */
  return `
    bg-primary bg-opacity-10
    text-primary
    border border-primary border-opacity-20
  `;
};